/**
 * Hook to get environment information
 * @returns {{
 *   environment: string,
 *   isProduction: boolean,
 *   isDevelopment: boolean,
 *   isQA: boolean,
 *   isUAT: boolean,
 *   isLoading: boolean
 * }}
 */
const useEnvironment = () => {
    const environment = sessionStorage.getItem('appEnvironment') ?? 'DEV';

    return {
        environment,
        isProduction: environment === 'PROD',
        isDevelopment: environment === 'DEV',
        isQA: environment === 'QA',
        isUAT: environment === 'UAT',
        isLoading: false
    };
};

export default useEnvironment;
